import { ThemeProvider } from "@emotion/react";
import { AccountCircle, MenuOutlined } from "@mui/icons-material";
import {
  AppBar,
  Box,
  createTheme,
  IconButton,
  Menu,
  MenuItem,
  Toolbar,
  Typography,
} from "@mui/material";
import { STheme } from "components/styles";
import React from "react";
import { Link } from "react-router-dom";
import { getLogoText } from "services";
import { Auth } from "states";

type Props = Partial<{
  auth: Auth;
  onDrawer: React.MouseEventHandler<HTMLButtonElement>;
  onMenu: React.MouseEventHandler<HTMLLIElement>;
}>;

export const SBar = ({ auth, onDrawer, onMenu }: Props) => {
  const logged = typeof auth !== "undefined";
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const handleMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  return (
    <ThemeProvider theme={theme}>
      <AppBar position="static">
        <Toolbar variant="dense">
          {logged && (
            <IconButton color="inherit" onClick={onDrawer} edge="start">
              <MenuOutlined />
            </IconButton>
          )}
          <Link to="/" style={{ textDecoration: "none", color: "white" }}>
            <Typography
              color="inherit"
              style={{ fontSize: "1.4rem", fontWeight: "bold" }}
            >
              {getLogoText()}
            </Typography>
          </Link>
          {logged && (
            <>
              <Box flexGrow={1} />
              <Typography color="inherit" style={{ fontSize: "0.8rem" }}>
                営業所: {`${auth?.eigyoNmr} ${auth?.shainNm}`}
              </Typography>
              <IconButton color="inherit" onClick={handleMenu}>
                <AccountCircle />
              </IconButton>
              <Menu
                id="menu-appbar"
                anchorEl={anchorEl}
                anchorOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                keepMounted
                transformOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                open={Boolean(anchorEl)}
                onClose={handleClose}
              >
                <MenuItem
                  onClick={(event) => {
                    handleClose();
                    onMenu?.call(this, event);
                  }}
                >
                  ログアウト
                </MenuItem>
              </Menu>
            </>
          )}
        </Toolbar>
      </AppBar>
    </ThemeProvider>
  );
};

const theme = createTheme(
  {
    components: {
      MuiAppBar: {
        styleOverrides: {
          root: {
            fontSize: "1.4rem",
            paddingLeft: "0px",
          },
          colorPrimary: {
            backgroundColor: STheme.frames.bar,
          },
        },
      },
      MuiToolbar: {
        styleOverrides: {
          root: {
            minHeight: "0px",
            paddingLeft: "5px",
            "@media (min-width: 600px)": {
              minHeight: "0px",
              paddingLeft: "5px",
            },
          },
        },
      },
    },
  },
  { ...STheme }
);
